import { useCallback, useEffect, useState } from "react";
import { useStateContext } from "../../contexts/ContextProvider";
import { Calendar } from "primereact/calendar";
import "primereact/resources/themes/lara-light-cyan/theme.css";

import Select from "react-select";
import HolidayShiftService from "../../services/holidayshift.service";
import AuthService from "../../services/auth.service";

import moment from "moment";

const HolidayShiftFilterModal = ({
  details,
  setDetails,
  handleFilter,
  clearFilter,
  requestOn,
  setRequestOn,
  tabIndex
}) => {
  const { filterBy, employees } = useStateContext();
  const currentDate = new Date();

  const user = AuthService.getCurrentUser();

  const [projects, setProjects] = useState([]);
  const [empOption, setEmpOption] = useState([]);

  const statusOptions = [
    { label: "Pending", value: "0" },
    { label: "Approved", value: "1" },
    { label: "Rejected", value: "2" },
  ];

  const handleDateChange = (e) => {
    setRequestOn(e.value);
    setDetails({
      ...details,
      date: moment(new Date(e.value)).format("YYYY-MM-DD"),
      formatedDate: moment(new Date(e.value)).format("D MMM YYYY"),
    });
  };

  useEffect(() => {
    const filteredEmployees = employees.map((item) => ({
      label: item.name,
      value: item.empId,
    }));
    setEmpOption(filteredEmployees);
  }, [employees]);

  const fetchProjects = useCallback(() => {
    HolidayShiftService.getListofProjects()
      .then((resp) => {
        if (resp.data) {
          const projectOptions = resp.data.map((item) => ({
            value: item.projectid,
            label: item.projectname,
          }));
          setProjects(projectOptions);
        }
      })
      .catch((e) => console.log(e));
  }, []);

  useEffect(() => {
    fetchProjects();
  }, [fetchProjects]);

  const handleSelectProject = (e) => {
    // console.log(e.value);
    setDetails((prev) => ({
      ...prev,
      project: e.label,
    }));
  };

  const handleSelectEmployee = (e) => {
    // console.log(e.value);
    setDetails((prev) => ({
      ...prev,
      employee: e.value,
    }));
  };

  const handleSelectStatus = (e) => {
    setDetails((prev) => ({
      ...prev,
      status: e.value,
    }));
  };

  // console.log("tabIndex", tabIndex)

  return (
    <>
      <div
        className={`${
          filterBy ? "filterByModal visible" : "filterByModal hidden"
        }`}
      >
        <div className="filter-flex">
          <div className="sort-list">
            <div className="heading mb-3">
              <span>Filter</span>
            </div>
            <div className="mb-3">
              <label htmlFor="leaveType" className="form-label">
                Projects
              </label>
              <Select
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    height: "45px",
                    border: "1px solid rgba(210, 205, 218, 1)",
                  }),
                  option: (baseStyles, { isFocused, isSelected }) => ({
                    ...baseStyles,
                    fontSize: "16px",
                    lineHeight: "20px",
                    borderRadius: "4px",
                    backgroundColor: isSelected
                      ? "rgba(177, 206, 251, 1)"
                      : isFocused
                        ? "rgba(177, 206, 251, 1)"
                        : "rgba(255, 255, 255, 1)",
                    color: isSelected
                      ? "rgba(78, 70, 94, 1)"
                      : isFocused
                        ? "rgba(78, 70, 94, 1)"
                        : "rgba(78, 70, 94, 1)",
                  }),
                  menu: (baseStyles, state) => ({
                    ...baseStyles,
                    backgroundColor: "rgba(255, 255, 255, 1)",
                    boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.25)",
                  }),
                }}
                options={projects}
                onChange={handleSelectProject}
                value={
                  Array.isArray(projects)
                    ? projects.filter(
                        (option) => option.label === details.project,
                      )
                    : null
                }
              />
            </div>
            {tabIndex === 1 && (user.role === "1" || user.role === "4") ? (
              <>
                {" "}
                <div className="mb-3">
                  <label htmlFor="leaveType" className="form-label">
                    Employee
                  </label>
                  <Select
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        height: "45px",
                        border: "1px solid rgba(210, 205, 218, 1)",
                      }),
                      option: (baseStyles, { isFocused, isSelected }) => ({
                        ...baseStyles,
                        fontSize: "16px",
                        lineHeight: "20px",
                        borderRadius: "4px",
                        backgroundColor: isSelected
                          ? "rgba(177, 206, 251, 1)"
                          : isFocused
                            ? "rgba(177, 206, 251, 1)"
                            : "rgba(255, 255, 255, 1)",
                        color: isSelected
                          ? "rgba(78, 70, 94, 1)"
                          : isFocused
                            ? "rgba(78, 70, 94, 1)"
                            : "rgba(78, 70, 94, 1)",
                      }),
                      menu: (baseStyles, state) => ({
                        ...baseStyles,
                        backgroundColor: "rgba(255, 255, 255, 1)",
                        boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.25)",
                      }),
                    }}
                    options={empOption}
                    onChange={handleSelectEmployee}
                    value={
                      Array.isArray(empOption)
                        ? empOption.filter(
                            (option) => option.value === details.employee,
                          )
                        : null
                    }
                  />
                </div>
              </>
            ) : null}

            <div className="mb-3">
              <label htmlFor="leaveType" className="form-label">
                {tabIndex === 0 ? "Request On" : "Date"}
              </label>
              <div>
                <Calendar
                  value={requestOn}
                  onChange={handleDateChange}
                  view="date"
                  dateFormat="dd, MM, yy"
                  style={{ width: "100%" }}
                  showIcon
                  maxDate={currentDate}
                  selectOtherMonths
                />
              </div>
            </div>

            {tabIndex === 0 ? (
              <>
                <div className="mb-3">
                  <label htmlFor="leaveType" className="form-label">
                    Status
                  </label>
                  <Select
                    styles={{
                      control: (baseStyles, state) => ({
                        ...baseStyles,
                        height: "45px",
                        border: "1px solid rgba(210, 205, 218, 1)",
                      }),
                      option: (baseStyles, { isFocused, isSelected }) => ({
                        ...baseStyles,
                        fontSize: "16px",
                        lineHeight: "20px",
                        borderRadius: "4px",
                        backgroundColor: isSelected
                          ? "rgba(177, 206, 251, 1)"
                          : isFocused
                            ? "rgba(177, 206, 251, 1)"
                            : "rgba(255, 255, 255, 1)",
                        color: isSelected
                          ? "rgba(78, 70, 94, 1)"
                          : isFocused
                            ? "rgba(78, 70, 94, 1)"
                            : "rgba(78, 70, 94, 1)",
                      }),
                      menu: (baseStyles, state) => ({
                        ...baseStyles,
                        backgroundColor: "rgba(255, 255, 255, 1)",
                        boxShadow: "0px 1px 8px 0px rgba(0, 0, 0, 0.25)",
                      }),
                    }}
                    options={statusOptions}
                    onChange={handleSelectStatus}
                    value={
                      Array.isArray(statusOptions)
                        ? statusOptions.filter(
                            (option) => option.value === details.status,
                          )
                        : null
                    }
                  />
                </div>
              </>
            ) : null}
          </div>
          <div className="sort-action">
            <button className="btn btn-reset" onClick={clearFilter}>
              Reset
            </button>
            <button className="btn btn-apply" onClick={handleFilter}>
              Apply
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default HolidayShiftFilterModal;
